import React, {useEffect, useMemo, useRef, useState } from 'react'

import { CalendarOutlined, CloseOutlined, CreditCardOutlined, FilterOutlined, FormOutlined, GiftFilled, GiftOutlined, MobileOutlined, NotificationOutlined, SaveOutlined, StarFilled, SyncOutlined, UserOutlined } from '@ant-design/icons'
import { Badge, Button, Col, Collapse, ConfigProvider, Form, Input, message, Modal, Row, Tabs, Tooltip, Typography } from 'antd'
import { orange, cyan, yellow,  purple, blue } from '@ant-design/colors';

import { apiEditAudience, apiGetPotentialAudience, apiSetAudience } from '../../../helpers/Api';
import PersonalDataFilters from './filters_group/filters_profile/PersonalDataFilters';
import { convertFullDateToDayjs, nowDateTimeIta } from '../../../helpers/DateUtils';
import EcommerceFilters from './filters_group/filters_product/EcommerceFilters';
import FidelityFilters from './filters_group/filters_fidelity/FidelityFilters';
import SoftwareFilters from './filters_group/filters_sofwares/SoftwareFilters';
import MarketingAudienceTopCarousel from './MarketingAudienceTopCarousel';
import UsersFilters from './filters_group/filters_user/UsersFilters';
import { CreateAudienceDataContext } from '../../../helpers/Context';
import { DEBUG_MODE, PRIMARY_COLOR } from '../../../helpers/Globals';
import confirmModal from '../../DiConfirmModal';

import BookingFilters from './filters_group/filters_booking/BookingFilters';


// Funzione per verificare se un valore è "compilato"
// const isValid = (value) => {
//   if (typeof value === 'boolean') {
//     return value === true; // Se è un booleano, è valido solo se è true
//   }
  
//   if (Array.isArray(value)) {
//     // L'array è valido se contiene almeno un oggetto valido
//     return value.some(item => {
//       if (typeof item === 'object' && item !== null) {
//         // L'oggetto è valido se ha almeno una chiave con valore valido
//         return Object.keys(item).length > 0 && Object.values(item).some(val => val !== undefined && val !== null && val !== '');
//       }
//       return false; // Ignora valori non oggetto (es. undefined, null, ecc.)
//     });
//   }

//   if (typeof value === 'object' && value !== null) {
//     // Se è un oggetto, deve avere almeno una chiave con valore valido
//     return Object.keys(value).length > 0 && Object.values(value).some(val => val !== undefined && val !== null && val !== '');
//   }
  
//   // Per qualsiasi altro tipo (stringhe, numeri, ecc.), consideriamo valido se non è vuoto
//   return value !== undefined && value !== null && value !== '';
// };

const isValid = (value) => {
  if (value === null || value === undefined) return false;

  if (typeof value === 'string') {
    return value.trim() !== '';
  }

  if (typeof value === 'number') {
    return true; // oppure valuta se lo vuoi accettare
  }

  if (typeof value === 'boolean') {
    return value === true;
  }

  if (Array.isArray(value)) {
    return value.some(isValid);
  }

  if (typeof value === 'object') {
    return Object.values(value).some(isValid);
  }

  return false;
};



const isFormNotEmpty = (form) => {
  const formValues = form.getFieldsValue(true); // Ottiene tutti i valori del form

  // Controlla se almeno un campo ha un valore valido
  return Object.values(formValues).some((value) => {
    if (value === null || value === undefined || value === '') {
      return false; // Campi vuoti non contano
    }
    if (Array.isArray(value)) {
      return value.length > 0; // Gli array devono avere almeno un elemento
    }
    if (typeof value === 'object') {
      return Object.keys(value).length > 0; // Gli oggetti devono avere almeno una chiave valida
    }
    return true; // Qualsiasi altro valore (stringhe, numeri, booleani) è valido
  });
};


export default function MarketingAudienceCreateContent({contextValue, closeModal, setShowCloseWarning, audienceData, onSave}) {

  const [loadingPotentialAudience, setLoadingPotentialAudience] = useState(false)
  const [disablePotentialAudience, setDisablePotentialAudience] = useState(false);
  const [potentialAudience, setPotentialAudience] = useState(0);
  const [savingAudience, setSavingAudience] = useState(false);

  const [formChanged, setFormChanged] = useState(0);
  const [formValues, setFormValues] = useState([])
  const [open, setOpen] = useState(false);

  const [audienceGeneralInfoForm] = Form.useForm();
  const [form] = Form.useForm();

  
  const {
    successNotification,
    serviceNotification,
    errorNotification,
    publicCode,
    diAppRef,
  } = contextValue;

  const globalContext = contextValue;
  const { appToken } = contextValue;
  
  // -------- gestione delle chiavi dei singoli collapse nei gruppi di filtri --------

  const keys = ['1', '2', '3', '4', '5', '6', '7','8','9'];
  const [activeKeysEcommerce, setactiveKeysEcommerce] = useState([])
  const [activeKeysFidelity, setactiveKeysFidelity] = useState([])
  const [activeKeysProfile, setactiveKeysProfile] = useState(["1"])
  const [activeKeysBooking, setactiveKeysBooking] = useState([])

  const explodeAllCollapse = () => {
    setactiveKeysEcommerce(keys);
    setactiveKeysFidelity(keys);
    setactiveKeysProfile(keys);
    setactiveKeysBooking(keys);
  }
  const closeAllCollapse = () => {
    setactiveKeysEcommerce([""]);
    setactiveKeysFidelity([""]);
    setactiveKeysProfile([""]);
    setactiveKeysBooking([""]);
  }
  // -------- gestione delle chiavi dei singoli collapse nei gruppi di filtri --------
  
  // -------- colori preset delle aree --------

  const colorProfile    = PRIMARY_COLOR;
  const colorFidelity   = orange[6];
  const colorEcommerce  = cyan[7];
  const colorUsers      = purple[5];
  const colorSoftwares  = yellow[6];
  const colorBooking    = blue[6];
  
  
  // -------- colori preset delle aree --------
  
  // -------- costanti delle singole liste di dati ----------

  
    // dati personali
    const [formInactiveUsersOnly, setformInactiveUsersOnly] = useState(null)
    const [formActiveUsersOnly, setformActiveUsersOnly] = useState(null)
    const [formActivationDates, setformActivationDates] = useState(null)
    const [formBirthdates, setformBirthdates] = useState(null)
    const [formBirthdays, setformBirthdays] = useState(null)
    const [formSurnames, setformSurnames] = useState(null)
    const [formGenders, setformGender] = useState(null)
    const [formNames, setformNames] = useState(null)
    const [formAges, setformAges] = useState(null)

 
    const arrayProfileValues = useMemo(() => [
      formActiveUsersOnly,
      formActivationDates,
      formBirthdates,
      formInactiveUsersOnly,
      formBirthdays,
      formSurnames,
      formGenders,
      formNames,
      formAges
    ], [formActiveUsersOnly, formActivationDates, formBirthdates, formInactiveUsersOnly, formBirthdays, formSurnames, formGenders, formNames, formAges]);

    const [showProfileDot, setShowProfileDot] = useState(false);
    // dati personali

    // dati fidelity
    const [formTransactions, setformTransactions] = useState(null)
    const [formCampaigns, setformCampaigns] = useState(null)
    const [formCoupons, setformCoupons] = useState(null)

    const arrayFidelityValues = useMemo(() => [
      formTransactions,
      formCampaigns,
      formCoupons,
    ], [formTransactions, formCampaigns, formCoupons]);

    const [showFidelityDot, setShowFidelityDot] = useState(false);
    // dati fidelity
  

    // dati ecommerce
    const [formShippingPayments, setformShippingPayments] = useState(null)
    const [formProducts, setformProducts] = useState(null)
    const [formOrders, setformOrders] = useState(null)

    const arrayEcommerceValues = useMemo(() => [
      formShippingPayments,
      formProducts,
      formOrders,
    ], [formShippingPayments, formProducts, formOrders]);

    const [showEcommerceDot, setShowEcommerceDot] = useState(false);
    // dati ecommerce
  
    // dati utenti
    const [formUsersIds, setFormUsersIds] = useState([]);
    const [showUsersDot, setShowUsersDot] = useState(false);
  
    // dati software
    const [formSoftwares, setformSoftwares] = useState([])
    const [showSoftwaresDot, setShowSoftwaresDot] = useState(false);
  
  // dati booking
    const [formBookings, setformBookings] = useState(null);
    const arrayBookingsValues = useMemo(() => [
      formBookings,
    ], [formBookings]);
    const [showBookingDot, setShowBookingDot] = useState(false);


    // Definisci un oggetto con i nomi delle variabili da settare
    const formFields = {
      activation_dates_list: setformActivationDates,
      birth_dates_list: setformBirthdates,
      surnames_list: setformSurnames,
      birthday_list: setformBirthdays,
      gender_list: setformGender,
      names_list: setformNames,
      age_list: setformAges,
      inactive_users_only: setformInactiveUsersOnly,
      active_users_only: setformActiveUsersOnly,

      transactions_list: setformTransactions,
      campaigns_list:setformCampaigns,
      coupons_list: setformCoupons,

      shippings_payments_list: setformShippingPayments,
      products_list:  setformProducts,
      orders_list: setformOrders,

      users_ids_list:setFormUsersIds,

      softwares_list: setformSoftwares,
    };
  
  // -------- costanti delle singole liste di dati ----------


   ///////////////////////////////////////////////////////////////////////////////////////////
      ////////// inizializzo dei valori del form se trattasi di modifica audience //////
   ///////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    if (!audienceData) return;
    form.setFieldsValue(convertFullDateToDayjs(audienceData));
  },[])

   /////////////////////////////////////////////////////////////////////////////////////////// 
      ////////// inizializzo dei valori del form se trattasi di modifica audience ////// 
   /////////////////////////////////////////////////////////////////////////////////////////// 
  
   ///////////////////////////////////////////////////////////////////////////////////////////
    //////////////////// funzione per salvare il pubblico nuovo o modificato ///////////////
  /////////////////////////////////////////////////////////////////////////////////////////// 
   
  const saveAudience = async () => {
    setSavingAudience(true);

    try {
      // Recupera i dati dal form
      const generalAudienceData = audienceGeneralInfoForm.getFieldsValue();

      const generalData = {
        title: generalAudienceData.audienceName, // Usa i valori aggiornati del form
        description: generalAudienceData.audienceDescription
      };

      const body = { ...generalData, ...formValues  };

      // Esegui chiamata API
      const res = audienceData
        ? await apiEditAudience(publicCode, audienceData.id, body)
        : await apiSetAudience(publicCode, body);

      if (!res?.message) {
        successNotification("Pubblico salvato con successo");
        setSavingAudience(false);
        closeModal(false); // Chiudi la pagina del pubblico solo dopo il successo
        setOpen(false); // Chiudi il modal
        if (onSave) {
          onSave(res.data.id) //salvo l'id in una variabile temporanea per rimandare a crare l'operazione su quel pubblico
        }
      } else {
        setSavingAudience(false);
        errorNotification(res.message);
        console.error("Errore nella risposta API:", res);
      }
    } catch (error) {
      setSavingAudience(false);
      console.error("Errore nel salvataggio dell'audience:", error);
      errorNotification("Errore durante il salvataggio del pubblico");
    }
    
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
   //////////////////// funzione per salvare il pubblico nuovo o modificato ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  
  ///////////////////////////////////////////////////////////////////////////////////////////
        //////////////////// aggiorno forzatamente il pubblico potenziale ///////////////
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  const getPotentialAudience = async () => {
    
    if (!publicCode) return;
    
    setLoadingPotentialAudience(true);

    const body = formValues;

    try {
      const res = await apiGetPotentialAudience(publicCode, body);
      if (!res.message) {
        setPotentialAudience(res.potentialUsers)
        setLoadingPotentialAudience(false);
      } else {
        errorNotification(res.message)
        setLoadingPotentialAudience(false);
        console.log(res)
      }
    } catch (error) {
      errorNotification(error)
      console.log(error)
    }
    
  }

  const loadPotentialAudience = () => {
    
    setDisablePotentialAudience(true);

    getPotentialAudience();

    setTimeout(() => {
      setDisablePotentialAudience(false)
    }, 10000);
  }

   /////////////////////////////////////////////////////////////////////////////////////////// 
        //////////////////// aggiorno forzatamente il pubblico potenziale ///////////////
  /////////////////////////////////////////////////////////////////////////////////////////// 
  

  const handleCancel = () => {
    setOpen(false);
  };

  //---------- gestione del click sul submit e invio form finito ------------
  const handleFinish = (values) => {
    if (formChanged === 0 && !audienceData) {
      serviceNotification("Sembra che tu non abbia fatto alcuna modifica")
      return
    }
    setFormValues(values);
    setOpen(true);
  }

  //---------- gestione del click sul submit e invio form finito ------------

  
  //---------- controllo del cambio dati del form non inviato ------------
    useEffect(() => {

      // ---- se almeno una modifica è stata fatta al form  ----
      if (formChanged > 0) {
        setShowCloseWarning(true);  //chiedo se si vuol chiudere la pagina
      }

      const formValues = form.getFieldsValue();
  
      // Itera su ogni campo e aggiorna il relativo stato
      Object.keys(formFields).forEach((key) => {
        if (formValues[key] !== undefined) {
          formFields[key](formValues[key]); // Chiamata dinamica a setformXXX
        }
      });
      // Infine, salva tutti i valori nel contesto principale
      setFormValues(formValues);

      if (DEBUG_MODE) {
         console.log("---- Valori del Form delle Audience ----");
         console.log(formValues);
         console.log("---- Valori del Form delle Audience ----");
      }

    }, [formChanged])
    
    useEffect(() => {
        
      const ecommerceHasValidValues = arrayEcommerceValues.some(isValid);
      const fidelityHasValidValues = arrayFidelityValues.some(isValid);
      const bookingHasValidValues = arrayBookingsValues.some(isValid);
      const profileHasValidValues = arrayProfileValues.some(isValid);
      const softwaresHasValidValues = formSoftwares.some(isValid); 
      const usersIdsHasValidValues = formUsersIds.some(isValid);
      
      setShowSoftwaresDot(softwaresHasValidValues);
      setShowEcommerceDot(ecommerceHasValidValues);
      setShowFidelityDot(fidelityHasValidValues);
      setShowProfileDot(profileHasValidValues);
      setShowUsersDot(usersIdsHasValidValues);
      setShowBookingDot(bookingHasValidValues);

    }, [arrayProfileValues, arrayFidelityValues, arrayEcommerceValues, formSoftwares]); // Trigger solo quando una delle variabili cambia
  //---------- controllo del cambio dati del form non inviato ------------

  //---------- reset dei campi filtri ------------
  const resetFormValues = () => {
    setPotentialAudience(0);
    form.resetFields();
      // Itera su ogni campo e aggiorna il relativo stato
      Object.keys(formFields).forEach((key) => {
        if (formValues[key] !== undefined) {
          formFields[key]([]); // Chiamata dinamica a setformXXX
        }
      });
  };

  const deleteFields = async () => {
    const result = await confirmModal(
      "Cliccando su si, cancellerai tutti i filtri impostati fi ora. Sicuro di voler procedere?",
      contextValue
    ); //attendo la risposta dal componente di conferma modale
    if (result) {
      resetFormValues()
      setFormChanged(formChanged + 1);
      closeAllCollapse();
    }
  }
  //---------- reset dei campi filtri ------------

  const handleFormChanged = () => {
    setFormChanged(formChanged + 1);
  }
  console.log(formValues)
  return (
    <CreateAudienceDataContext.Provider value={{
        globalContext,

        audienceGeneralInfoForm,
        audienceData,
        form,
        
        diAppRef,

        setactiveKeysBooking,
        setactiveKeysEcommerce,
        setactiveKeysFidelity,
        setactiveKeysProfile,
        activeKeysEcommerce,
        activeKeysBooking,
        explodeAllCollapse,
        activeKeysFidelity,
        activeKeysProfile,
        closeAllCollapse,
        keys,
          
        colorSoftwares, 
        colorEcommerce,
        colorFidelity,
        colorProfile,
        colorBooking,
        colorUsers,
          
        handleFormChanged,
        setFormChanged,
        formChanged,
        formValues,
        
        resetFormValues,
        deleteFields,
        
        formActivationDates,
        formActiveUsersOnly,
        formInactiveUsersOnly,
        formBirthdates,
        formBirthdays,
        formSurnames,
        formGenders,
        formNames,
        formAges,
        
        formTransactions,
        formCampaigns,
        formCoupons,

        formShippingPayments,
        formProducts,
        formOrders,
        
        arrayBookingsValues,
        
        formSoftwares,
        formFields,
      }}
    >
        {/* ------------ componente form che wrappa le singole tab che procurano i campi ------------ */}
        <Form
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          scrollToFirstError={{ behavior: 'instant', block: 'end', focus: true }}
          onValuesChange={() => setFormChanged(formChanged + 1)}
          onFinish={handleFinish}
          name="audience_form"
          layout='vertical'
          form={form}
        > 
            
          {/* ------------ Prima riga con il monitor utenti e azioni -----------— */}
          <div className='p-10'>
            <div className='bg-dark-02 p-20 radius-2  w-100'>
              <div className='flex flex-wrap gap-20 align-center space-between'>
                <div className='flex flex-wrap gap-20 align-center' ref={diAppRef.refPotentialAudience}>
                  <Badge count={potentialAudience} overflowCount={99999}>
                    <UserOutlined className='fs-25 color-primary' />
                  </Badge> 
                  <span className='flex align-center justify-center'>
                    <Typography className='bold'>Pubblico Potenziale</Typography>
                    <Tooltip title="Possibilità attiva ogni 10 secondi">
                      <Button disabled={disablePotentialAudience} onClick={loadPotentialAudience} icon={<SyncOutlined spin={loadingPotentialAudience} />} type='text' shape='circle' />
                    </Tooltip>
                  </span>
                </div>
                <Button ref={diAppRef.refAudienceSave} htmlType="submit" type='primary' icon={<SaveOutlined />}>
                  Salva pubblico
                </Button>
              </div>
            </div>
          </div>
          {/* ------------ Prima riga con il monitor utenti e azioni -----------— */}
    
          {/* ------------ accordion con carosello di pubblici consigliati -----------— */}
          <Collapse
          className='di-audience-collapse mt-20'
           ref={diAppRef.refTopAudiencesCarousel}
            expandIconPosition='end'
            defaultActiveKey={["1"]}
            bordered={false}
            items={[
              {
                key: '1',
                label: (
                  <div className='flex gap-5'>
                    <StarFilled className='color-yellow' />
                    <Typography.Text>I preset più usati dagli utenti</Typography.Text>
                  </div>
                ),
                children: <div><MarketingAudienceTopCarousel  form={form}/></div>,
              },
            ]}
          />
          {/* ------------ accordion con carosello di pubblici consigliati -----------— */}
    
          {/* ------------ tabs con sezioni di filtri dinamici -----------— */}
          <div className='flex align-center space-between gap-10 mt-20 px-15'>
            <div className='flex align-center gap-10'>
                <FilterOutlined className='color-primary'/>
                <Typography>
                  Scegli i filtri per il pubblico
                </Typography>
            </div>
            {(showEcommerceDot || showFidelityDot || showProfileDot || showSoftwaresDot) &&
              <Button icon={
                <Badge count={<CloseOutlined className='fs-8'/>}>
                  <FilterOutlined/>
                </Badge>
              }
                onClick={deleteFields}
              >
                Reset filtri
              </Button>
              }
          </div>
    
          
            <Tabs
              className='di-audience-filters-group-tabs mt-20'
              defaultActiveKey="1"
              size="large"
              type="card"
              items={[
                {
                  key: '1',
                  forceRender: true,
                  icon: <FormOutlined />,
                  label:
                    <Badge  ref={diAppRef.refAudienceTabsHeader} color={colorProfile} dot={showProfileDot} className={showProfileDot && "pulse"}>
                        Anagrafica
                    </Badge>,
                  children: (
                      <div className='di-tab-audience-filter filters-group-profile'>
                         <PersonalDataFilters form={form} />
                      </div>
                  ),
                },
                {
                  key: '2',
                  forceRender:true,
                  disabled:false,
                  icon: <GiftOutlined />,
                  label:
                    <Badge color={colorFidelity}  dot={showFidelityDot} className={showFidelityDot && "pulse"}>
                        Fidelity / Coupons
                    </Badge>,
                  children: (
                    <ConfigProvider
                       theme={
                        {
                          token:{
                            colorPrimary: colorFidelity,
                            }
                          }
                        }
                    >
                      <div className='di-tab-audience-filter filters-group-fidelity'>
                        <FidelityFilters form={form} />
                      </div>
                    </ConfigProvider>
                  ),
                },
                {
                  key: '3',
                  forceRender: true,
                  disabled:false,
                  icon: <CreditCardOutlined />,
                  label:
                    <Badge color={colorEcommerce} dot={showEcommerceDot} className={showEcommerceDot && "pulse"}>
                        Venduto
                    </Badge>,
                  children: (
                    <ConfigProvider
                        theme={
                          {
                              token:{
                                colorPrimary: colorEcommerce ,
                              }
                            }
                          }
                      >
                        <div className='di-tab-audience-filter filters-group-ecommerce'>
                          <EcommerceFilters form={form} />
                        </div>
                    </ConfigProvider>
                  ),
                },
                {
                  key: '4',
                  forceRender: true,
                  disabled:false,
                  icon: <UserOutlined />,
                  label:<Badge color={colorUsers} dot={showUsersDot} className={showUsersDot && "pulse"}>Lista Utenti</Badge>,
                  children: (
                      <ConfigProvider
                        theme={
                          {
                              token:{
                                colorPrimary:colorUsers,
                              }
                            }
                          }
                      >
                      <div className='di-tab-audience-filter filters-group-users'>
                        <UsersFilters form={form} />
                      </div>
                    </ConfigProvider>
                  ),
                },
                {
                  key: '5',
                  forceRender: true,
                  disabled:true,
                  icon: <MobileOutlined />,
                  label:<Badge color={colorSoftwares} dot={showSoftwaresDot} className={showSoftwaresDot && "pulse"}>Fonti</Badge>,
                  children: (
                    <ConfigProvider
                      theme={
                        {
                            token:{
                              colorPrimary: colorSoftwares ,
                            }
                          }
                        }
                    >
                      <div className='di-tab-audience-filter filters-group-softwares'>
                        <SoftwareFilters form={form} />
                      </div>
                   </ConfigProvider>
                  ),
                },
                {
                  key: '6',
                  forceRender: true,
                  disabled:true,
                  icon: <CalendarOutlined />,
                  label:<Badge color={colorBooking} dot={showBookingDot} className={showBookingDot && "pulse"}>Prenotazioni</Badge>,
                  children: (
                    <ConfigProvider
                      theme={
                        {
                            token:{
                              colorPrimary: colorBooking ,
                            }
                          }
                        }
                    >
                      <div className='di-tab-audience-filter filters-group-booking'>
                        <BookingFilters form={form} />
                      </div>
                   </ConfigProvider>
                  ),
                },
              ]}
            />
          {/* ------------ tabs con sezioni di filtri dinamici -----------— */}
        
          {/* ------------ modal per salvare i dati -----------— */}
          <Modal
            title="Prima di salvare..."
            onCancel={handleCancel}
            cancelText="Annulla"
            onOk={saveAudience}
            okButtonProps={{
              disabled: savingAudience,
              loading:savingAudience
            }}
            okText={<><SaveOutlined /> Salva</>}
            open={open}
          >
          <Typography className='mb-20'>Diamo a questo pubblico alcune info per permetterti di capire subito il target</Typography>
            <Form form={audienceGeneralInfoForm} layout="vertical">
            
              <Form.Item 
                name="audienceName" 
                initialValue={audienceData ? audienceData.title : `Pubblico del ${nowDateTimeIta}`}
              >
                <Input 
                  placeholder={`Pubblico del ${nowDateTimeIta}`} 
                  prefix={<UserOutlined />}
                  maxLength={50}
                  showCount
                  size="large"
                />
              </Form.Item>

              <Form.Item
                name="audienceDescription"
                initialValue={audienceData ? audienceData.description : ``}
              >
                <Input.TextArea
                  placeholder="Descrizione del pubblico"
                  className="mt-10 mb-20"
                  maxLength={150}
                  showCount
                  style={{ height: 120 }}
                />
              </Form.Item>
            </Form>
          </Modal>
          {/* ------------ modal per salvare i dati -----------— */}

  
        </Form>
      {/* ------------ componente form che wrappa le singole tab che procurano i campi ------------ */}
      
    </CreateAudienceDataContext.Provider>
  )
}
